import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    components: {
        MuiMenu: {
            styleOverrides: {
                paper: {
                    backgroundColor: 'var(--background-paper-elevator-6)',
                    backgroundImage: 'none',
                },
            },
        },
        MuiPopover: {
            styleOverrides: {
                paper: {
                    backgroundColor: 'var(--background-paper-elevator-6)',
                    backgroundImage: 'none',
                },
            },
        },
        MuiPopper: {
            styleOverrides: {
                root: {
                    '& .MuiPaper-root': {
                        backgroundColor: 'var(--background-paper-elevator-6)',
                        backgroundImage: 'none',
                    },
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    backgroundColor: 'var(--color-tooltip-fill)',
                    color: 'var(--color-white)',
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                },
                contained: {
                    '&.MuiButton-containedPrimary': {
                        background: 'var(--color-primary-main)',
                        color: 'var(--color-white)',
                        boxShadow: 'none',
                        '&:hover': {
                            background: 'var(--primary-blue-blue-A4)',
                        },
                        '&:active': {
                            background: 'var(--primary-blue-blue-A4)',
                        },
                        '&.Mui-disabled': {
                            background: 'var(--primary-blue-blue-t1)',
                            border: '1px solid var(--primary-blue-blue-t2)',
                        },
                    },
                },
                text: {
                    '&.MuiButton-sizeSmall': {
                        display: 'flex',
                        flexDirection: 'row',
                        padding: '4px 5px',
                        gap: '4px',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: '4px',
                        fontSize: '13px',
                        fontStyle: 'normal',
                        fontWeight: '500',
                        lineHeight: '22px',
                        letterSpacing: '0.46px',
                        '& .MuiButton-iconSizeSmall': {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: 0,
                        },
                    },
                    '&.MuiButton-sizeMedium': {
                        display: 'flex',
                        flexDirection: 'row',
                        padding: '6px 8px',
                        gap: '6px',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: '4px',
                        fontSize: '14px',
                        fontStyle: 'normal',
                        fontWeight: '500',
                        lineHeight: '24px',
                        letterSpacing: '0.4px',
                        '& .MuiButton-iconSizeMedium': {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: 0,
                        },
                    },
                    '&.MuiButton-sizeLarge': {
                        display: 'flex',
                        flexDirection: 'row',
                        padding: '8px 11px',
                        gap: '8px',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: '4px',
                        fontSize: '15px',
                        fontStyle: 'normal',
                        fontWeight: '500',
                        lineHeight: '26px',
                        letterSpacing: '0.46px',
                        '& .MuiButton-iconSizeLarge': {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: 0,
                        },
                    },
                },
                textPrimary: {
                    color: 'var(--color-primary-main)',
                    '&:hover': {
                        backgroundColor: 'var(--button-primary-hover)',
                    },
                },
                textSecondary: {
                    color: 'var(--color-secondary-main)',
                    '&:hover': {
                        backgroundColor: 'var(--button-secondary-hover)',
                    },
                },
            },
        },
        MuiIconButton: {
            styleOverrides: {
                colorPrimary: {
                    color: 'var(--color-primary-main)',
                    '&.Mui-disabled': {
                        color: 'var(--button-primary-disabled)',
                    },
                },
                colorSecondary: {
                    color: 'var(--button-secondary)',
                    '&.Mui-disabled': {
                        color: 'var(--button-secondary-disabled)',
                    },
                },
            },
        },
    },
});

export default theme;
